// Local development
// export const baseUrl = "http://localhost:3002/api/";
// export const baseImageUrl = "http://localhost:3002/";

// Production — relative URLs work on any domain
export const baseUrl = "/api/";
export const baseImageUrl = "/uploads/";
